import React, {
  FC,
  MouseEventHandler,
  createRef,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { CatalogDetail } from '../../apis/detail-catalog';
import { Container } from '../../components/container/container';
import { Step } from '../../components/step/step';
// @ts-ignore
import renderHTML from 'react-render-html';
import { Info } from '../../components/info/info';
import { Tag } from '../../components/tag/tag';
import {
  BreadcrumbsProps,
  Button,
  Checkbox,
  DepartmentSections,
  Option,
  ServiceLocation,
  Title,
} from '@plataformaxvia/design-system';
import { HeaderDetail } from '../../components/header-detail/header-detail';
import { message } from 'antd';
import {
  AccordionDetailsInfo,
  AccordionDetailsStyled,
  AccordionMarker,
  AccordionStyled,
  AccordionSummaryStyled,
  BaseAccordion,
  BaseButton,
  BaseButtonFeedback,
  BoxTextField,
  CatalogButton,
  CatalogDetailStyled,
  CatalogTitle,
  CatalogTitleBase,
  CountEvaluation,
  DetailBase,
  DetailStyled,
  DividerStyled,
  FeedbackText,
  OpinionAction,
  OpinionCheckbox,
  OpinionFeedback,
  OpinionSubTitle,
  OpinionTitle,
  ServiceLocationBase,
  TextFieldStyled,
} from './style';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WarningIcon from '@mui/icons-material/Warning';
import { stripHtml } from '../../util/html';
import { WarningModal } from '../../components/warning-modal/WarningModal';
import { ContainerModalAction } from '../../components/warning-modal/style';
import { CircularProgress, Collapse } from '@mui/material';
import {
  EvaluationCount,
  EvaluationReasons,
  Reasons,
} from '../../apis/service-evaluation';
import { ICity } from '../../util/municipios';
export interface CatalogProps extends CatalogDetail {
  onPdfClick?: MouseEventHandler;
  onServiceClick?: MouseEventHandler;
  breadcrumbs: BreadcrumbsProps;
  allDepartmentLocation: DepartmentSections[];
  departamentLocation: DepartmentSections[];
  buttonLabel: string;
  departmentName: string;
  departmentOption: Option | null;
  cityOption: Option | null;
  availableCities: ICity[];
  setDepartmentOption: (option: Option | null) => void;
  setCityOption: (option: Option | null) => void;
  isRedirectWarningModalOpen?: boolean;
  toggleRedirectWarningModal: () => void;
  handleRedirectWarningModalConfirm: () => void;
  setCurrentServiceRedirectLink: (link: string) => void;
  mapUrl: string;
  evaluationReasons: EvaluationReasons[];
  onAddEvaluation: (
    avaliacao: number,
    comentario?: string,
    motivos?: Reasons[]
  ) => void;
  countEvaluation: EvaluationCount;
  hasEvaluated: boolean;
  isLoadingEvaluation: boolean;
}

export const Catalog: FC<CatalogProps> = ({
  name,
  onPdfClick,
  onServiceClick,
  description,
  info,
  steps,
  tags,
  breadcrumbs,
  availableCities,
  allDepartmentLocation,
  departamentLocation,
  buttonLabel,
  isRedirectWarningModalOpen = false,
  toggleRedirectWarningModal,
  handleRedirectWarningModalConfirm,
  setCurrentServiceRedirectLink,
  departmentName,
  departmentOption,
  setDepartmentOption,
  mapUrl,
  evaluationReasons,
  onAddEvaluation,
  countEvaluation,
  hasEvaluated,
  isLoadingEvaluation,
  cityOption,
  setCityOption,
}) => {
  const [expanded, setExpanded] = useState<string[]>(['info', 'tag']);
  const [showFeedbackOptions, setShowFeedbackOptions] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [selectedReasons, setSelectedReasons] = useState<Reasons[]>([]);

  useEffect(() => {
    if (steps?.length > 0) {
      setExpanded((prev) => [...prev, ...steps.map((step) => step.id)]);
    }
  }, [steps]);

  const handleAccordionChange =
    (panel: string) => (_: any, isExpanded: boolean) => {
      setExpanded((prevExpanded) =>
        isExpanded
          ? [...prevExpanded, panel]
          : prevExpanded.filter((id) => id !== panel)
      );
    };

  const handleNoClick = () => {
    setShowFeedbackOptions((prev) => !prev);
  };

  const handleFeedbackChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const text = event.target.value;
    if (text.length <= 200) {
      setFeedbackText(text);
    }
  };

  const handleReasonChange = (reasonId: number) => {
    setSelectedReasons((prevSelected) =>
      prevSelected.some((reason) => reason.idMotivo === reasonId)
        ? prevSelected.filter((reason) => reason.idMotivo !== reasonId)
        : [...prevSelected, { idMotivo: reasonId }]
    );
  };

  const handleFeedback = (
    avaliacao: number,
    comentario?: string,
    motivos?: Reasons[]
  ) => {
    if (hasEvaluated) {
      message.info('Sua avaliação já foi realizada');
      return;
    }
    onAddEvaluation(avaliacao, comentario, motivos);
    setShowFeedbackOptions(false);
  };

  const handleFeedbackNo = () =>
    handleFeedback(0, feedbackText, selectedReasons);

  const handleFeedbackYes = () => handleFeedback(1);

  return (
    <>
      <HeaderDetail breadcrumbs={breadcrumbs} />
      <DetailBase>
        <Container>
          <CatalogTitleBase>
            <CatalogTitle>
              <Title
                description={stripHtml(description)}
                info={departmentName}
                infoBehavior="ellipsis"
                title={name}
                as={'h2'}
              />
            </CatalogTitle>
            <CatalogButton>
              {buttonLabel && (
                <Button
                  iconStart={<CalendarTodayIcon />}
                  label={buttonLabel}
                  size="large"
                  onClick={onServiceClick}
                  aria-label={buttonLabel}
                />
              )}
              <Button
                iconStart={<PictureAsPdfIcon />}
                label="Baixar como PDF"
                size="none"
                variant="text"
                onClick={onPdfClick}
                aria-label="Baixar como PDF"
              />
            </CatalogButton>
          </CatalogTitleBase>
          <DividerStyled />
          <CatalogDetailStyled>
            <DetailStyled>
              {steps?.length > 0 && (
                <>
                  {steps?.map((step) => (
                    <BaseAccordion
                      key={step.id}
                      isExpanded={expanded.includes(step.id)}
                    >
                      <AccordionMarker className="marker" />
                      <AccordionStyled
                        expanded={expanded.includes(step.id)}
                        onChange={handleAccordionChange(step.id)}
                        defaultExpanded
                      >
                        <AccordionSummaryStyled
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          {step.channel === 'online'
                            ? 'Online - Canal de atendimento digital'
                            : 'Presencial - Unidades do governo'}
                        </AccordionSummaryStyled>
                        <AccordionDetailsStyled>
                          <Step number={step.orderIndex} title={step.name}>
                            <DescriptionHTML
                              description={step.description}
                              toggleRedirectWarningModal={
                                toggleRedirectWarningModal
                              }
                              setCurrentServiceRedirectLink={
                                setCurrentServiceRedirectLink
                              }
                            />
                            {step.documents.length > 0 && (
                              <div>
                                <h3>Documentos necessários</h3>
                                {step.documents.map((doc, docIndex) => (
                                  <Info
                                    key={docIndex}
                                    text={doc}
                                    icon="fa-check"
                                  />
                                ))}
                              </div>
                            )}
                          </Step>
                        </AccordionDetailsStyled>
                      </AccordionStyled>
                    </BaseAccordion>
                  ))}
                </>
              )}
              {info?.length > 0 && (
                <BaseAccordion isExpanded={expanded.includes('info')}>
                  <AccordionMarker className="marker" />
                  <AccordionStyled
                    expanded={expanded.includes('info')}
                    onChange={handleAccordionChange('info')}
                  >
                    <AccordionSummaryStyled
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="Painel - Informação"
                      id="info"
                    >
                      Informações
                    </AccordionSummaryStyled>
                    <AccordionDetailsStyled>
                      <AccordionDetailsInfo>
                        {info.map((item) =>
                          item.text ? (
                            <Step
                              key={item.id}
                              icon={item.icon}
                              title={item.title}
                            >
                              <DescriptionHTML
                                description={item.text}
                                toggleRedirectWarningModal={
                                  toggleRedirectWarningModal
                                }
                                setCurrentServiceRedirectLink={
                                  setCurrentServiceRedirectLink
                                }
                                title={item.title}
                              />
                            </Step>
                          ) : null
                        )}
                      </AccordionDetailsInfo>
                    </AccordionDetailsStyled>
                  </AccordionStyled>
                </BaseAccordion>
              )}
              {tags?.length > 0 && (
                <BaseAccordion isExpanded={expanded.includes('tag')}>
                  <AccordionMarker className="marker" />
                  <AccordionStyled
                    expanded={expanded.includes('tag')}
                    onChange={handleAccordionChange('tag')}
                  >
                    <AccordionSummaryStyled
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="Painel - tag"
                      id="tag"
                    >
                      Tags
                    </AccordionSummaryStyled>
                    <AccordionDetailsStyled>
                      {tags.map((tagItem, tagIndex) => (
                        <Tag
                          key={tagIndex}
                          href={`/app/catalog/carta-de-servicos?tag=${encodeURIComponent(
                            tagItem
                          )}`}
                          aria-label={`Tag ${tagItem}`}
                        >
                          {tagItem}
                        </Tag>
                      ))}
                    </AccordionDetailsStyled>
                  </AccordionStyled>
                </BaseAccordion>
              )}
              <OpinionTitle>
                <Title as="h2" title="Nos deixe saber a sua opinião" />
                <OpinionSubTitle>
                  Este conteúdo foi útil para você?
                </OpinionSubTitle>
                <OpinionAction>
                  <BaseButton>
                    <Button
                      iconStart={<ThumbUpAltIcon />}
                      label="sim"
                      size="small"
                      variant="primary"
                      disabled={isLoadingEvaluation}
                      onClick={() => handleFeedbackYes()}
                    />
                    {hasEvaluated && countEvaluation && (
                      <CountEvaluation>
                        ({countEvaluation.positivas ?? 0})
                      </CountEvaluation>
                    )}
                  </BaseButton>
                  <BaseButton>
                    <Button
                      iconStart={<ThumbDownAltIcon />}
                      label="não"
                      size="small"
                      variant={showFeedbackOptions ? 'default' : 'error'}
                      style={{
                        backgroundColor: showFeedbackOptions
                          ? 'var(--color-error)'
                          : '',
                        color: showFeedbackOptions ? '#ffffff' : '',
                      }}
                      disabled={isLoadingEvaluation}
                      onClick={hasEvaluated ? handleFeedbackNo : handleNoClick}
                    />
                    {hasEvaluated && countEvaluation && (
                      <CountEvaluation>
                        ({countEvaluation.negativas ?? 0})
                      </CountEvaluation>
                    )}
                  </BaseButton>
                </OpinionAction>
                {isLoadingEvaluation && (
                  <div style={{ display: 'flex', justifyContent: 'start' }}>
                    <CircularProgress size={16} />
                  </div>
                )}
                <Collapse in={showFeedbackOptions} timeout="auto" unmountOnExit>
                  <OpinionFeedback>
                    Nos ajude a melhorar:
                    {evaluationReasons
                      .sort((a, b) => a.id - b.id)
                      .map((reason) => (
                        <OpinionCheckbox key={reason.id}>
                          <Checkbox
                            id={`feedback-checkbox-${reason.id}`}
                            setChecked={() => handleReasonChange(reason.id)}
                            checked={selectedReasons.some(
                              (selectedReason) =>
                                selectedReason.idMotivo === reason.id
                            )}
                            variant="secondary"
                          />
                          <label
                            htmlFor={`feedback-checkbox-${reason.id}`}
                            aria-label={reason.descricao}
                          >
                            {reason.descricao}
                          </label>
                        </OpinionCheckbox>
                      ))}
                    Comentários
                    <BoxTextField>
                      <TextFieldStyled
                        placeholder="Deixe aqui seu comentário para nos ajudar a melhorar as informações sobre o serviço..."
                        multiline
                        rows={4}
                        variant="standard"
                        fullWidth
                        value={feedbackText}
                        onChange={handleFeedbackChange}
                        inputProps={{
                          maxLength: 200,
                        }}
                      />
                      <FeedbackText>
                        {`${200 - feedbackText.length} caracteres restantes`}
                      </FeedbackText>
                    </BoxTextField>
                    <BaseButtonFeedback>
                      <Button
                        label="Enviar avaliação"
                        variant="default"
                        onClick={() => handleFeedbackNo()}
                        disabled={hasEvaluated}
                      />
                    </BaseButtonFeedback>
                  </OpinionFeedback>
                </Collapse>
              </OpinionTitle>
            </DetailStyled>
            {allDepartmentLocation?.length > 0 && (
              <ServiceLocationBase>
                <ServiceLocation
                  mapUrl={mapUrl}
                  department={departmentOption}
                  departmentSections={departamentLocation}
                  setDepartment={setDepartmentOption}
                  citySections={availableCities}
                  city={cityOption}
                  setCity={setCityOption}
                  title={'Buscar local de atendimento'}
                  asTitle="h2"
                />
              </ServiceLocationBase>
            )}
          </CatalogDetailStyled>
        </Container>
      </DetailBase>
      <WarningModal
        headerTitle="Atenção!"
        icon={<WarningIcon />}
        headerBgColor="#F5A623"
        onCloseModal={toggleRedirectWarningModal}
        modalOpen={isRedirectWarningModalOpen}
      >
        <p aria-label="Você está sendo redirecionado para um link externo. Tem certeza que deseja continuar?">
          Você está sendo redirecionado para um link externo. Tem certeza que
          deseja continuar?
        </p>

        <ContainerModalAction>
          <Button
            onClick={handleRedirectWarningModalConfirm}
            label="Confirmar redirecionamento"
            aria-label="Confirmar redirecionamento"
          />
        </ContainerModalAction>
      </WarningModal>
    </>
  );
};

type DescriptionHTMLProps = Pick<
  CatalogProps,
  'description' | 'toggleRedirectWarningModal' | 'setCurrentServiceRedirectLink'
> & {
  title?: string;
};

const DescriptionHTML: React.FC<DescriptionHTMLProps> = ({
  description,
  toggleRedirectWarningModal,
  setCurrentServiceRedirectLink,
  title,
}) => {
  const descriptionHTMLRef = createRef<HTMLDivElement>();

  const handleDescriptionHTMLAnchorClick = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();

      const anchor = event.target as HTMLAnchorElement;

      setCurrentServiceRedirectLink(anchor.href);
      toggleRedirectWarningModal();
    },
    [setCurrentServiceRedirectLink, toggleRedirectWarningModal]
  );

  useEffect(() => {
    if (!descriptionHTMLRef.current) {
      return;
    }

    const anchors = descriptionHTMLRef.current.querySelectorAll('a');

    anchors.forEach((anchor) => {
      anchor.target = '_blank';
      anchor.addEventListener('click', handleDescriptionHTMLAnchorClick);

      if (title === 'Canais de Atendimento') {
        anchor.classList.add('service-detail-redirect-button');
        anchor.innerHTML = 'Acessar';
      }
    });

    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleDescriptionHTMLAnchorClick);
      });
    };
  }, [descriptionHTMLRef, handleDescriptionHTMLAnchorClick, title]);

  return <div ref={descriptionHTMLRef}>{renderHTML(description)}</div>;
};
